import React, { Fragment } from 'react';
import { get } from 'lodash';
import { Translate, TranslateHTML } from 'core/translate';
import Currency from '../../common/intl/Currency';
import computePriceChange from './computePriceChange';

const split = (input, splitter) => {
  const regexp = new RegExp(splitter);
  return input && input.split(regexp);
};

const PackageList = ({ option }) => {
  const isPackage = option.consumerFriendlyHeaderName === 'Package';

  if (!isPackage) {
    return null;
  }

  const lines = split(option.extendedCFD, 'and|,|includes').map(
    (line, index) =>
      line ? (
        <li key={index}>
          <span dangerouslySetInnerHTML={{ __html: line }} />
        </li>
      ) : null
  );

  return (
    <ul style={{ marginLeft: 10 }}>
      <span className="package-includes-label">
        <Translate value="package.includes" />
      </span>
      {lines}
    </ul>
  );
};

const OptionList = ({ header, options }) => {
  if (options.length === 0) {
    return null;
  }
  return (
    <div>
      <div className="modal-body__label option-conflict__label">{header}</div>
      <ul className="option-conflict__list">
        {options.map(option => {
          return (
            <li key={option.id}>
              <span dangerouslySetInnerHTML={{ __html: option.description }} />
              <PackageList option={option} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const getOptionDescription = option =>
  option.formattedConfig || option.shortCFD || option.description;

const OptionConflictPriceChange = props => {
  const { previousConfig, conflictConfig, hidePrice } = props;

  if (hidePrice) {
    return null;
  }

  const content = conflictConfig.msrp.isActualPrice ? (
    <span>
      <Translate value="price.change" />{' '}
      <span className="option-conflict__price">
        <Currency
          value={computePriceChange(previousConfig.msrp, conflictConfig.msrp)}
        />
      </span>
    </span>
  ) : (
    <span>
      <Translate value="unknown.price.text" />
    </span>
  );

  return <div className="modal-body__label">{content}</div>;
};

const OptionConflictConfirmation = props => {
  const { option, previousConfig, conflictConfig, hidePrice } = props;

  const addedOptions = get(
    conflictConfig,
    'config.TOGGLE_CHECK.addOptions',
    []
  );
  const deletedOptions = get(
    conflictConfig,
    'config.TOGGLE_CHECK.deleteOptions',
    []
  );

  return (
    <Fragment>
      <div className="modal-body__subheader">
        <TranslateHTML
          value="conflict.header"
          description={getOptionDescription(option)}
        />
      </div>
      <OptionList
        header={<Translate value="component.options.remove" />}
        options={deletedOptions}
      />
      <OptionList
        header={<Translate value="component.options.add" />}
        options={addedOptions}
      />
      <OptionConflictPriceChange
        previousConfig={previousConfig}
        conflictConfig={conflictConfig}
        hidePrice={hidePrice}
      />
    </Fragment>
  );
};

export default OptionConflictConfirmation;
